/* NALLI — readymade product form (WS7).
 *
 * DECISION (documented in rebuild/ws7-notes.md): template-scoped module load,
 * NOT an importmap shadow. Live shadowed `@theme/product-form` in
 * snippets/scripts.liquid (duplicate key, last-key-wins) with a 457-line copy
 * of the 2.x product-form.js renamed to `readymade-product-form-component`.
 *
 * Re-validation against 4.1.3: live's readymade file is byte-for-byte the OLD
 * 2.x stock ProductFormComponent behavior (its only purpose was to OPT OUT of
 * live's voucher/multi-item hacks in the patched core product-form.js). On the
 * rebuild, core 4.1.3 product-form.js is pristine — the voucher gate and
 * allocation live in separate capture-phase modules — so the readymade form
 * needs NO divergent behavior. It only needs the `readymade-product-form-component`
 * element name to exist (the nalli-buy-buttons fork renders that tag for
 * READYMADE products, preserving live markup/CSS hooks and giving us a seam if
 * readymade behavior ever diverges again).
 *
 * Implementation: subclass the registered 4.1.3 component via
 * customElements.get() — zero core edits, zero forked logic to maintain, and
 * the old 2.x API (ThemeEvents/CartAddEvent/VariantUpdateEvent) is dropped in
 * favor of whatever the parent class currently implements
 * (@shopify/events StandardEvents on 4.1.3).
 *
 * Loaded ONLY from blocks/nalli-buy-buttons.liquid when the product carries a
 * READYMADE* tag; snippets/scripts.liquid stays byte-pristine.
 */

import '@theme/product-form';

async function define() {
  await customElements.whenDefined('product-form-component');
  const BaseProductFormComponent = customElements.get('product-form-component');

  if (!BaseProductFormComponent) {
    console.error('[nalli-readymade-form] product-form-component is not registered');
    return;
  }

  if (!customElements.get('readymade-product-form-component')) {
    customElements.define(
      'readymade-product-form-component',
      class ReadymadeProductFormComponent extends BaseProductFormComponent {}
    );
  }
}

define();
